/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useCallback, useContext } from 'react';

import { Row, Col } from 'antd';

import ThemeContext from '../../context/theme';
import useMobile from '../../hooks/useMobile';

interface Props {
  exchanges: React.ReactNode[];
  bottomNav: React.ReactNode;
  compare: React.ReactNode;

  select: number;
  isMobile: boolean;
  fab: React.ReactNode;
}

const ONE_DIVISION = 24;

const CoinDashBoard = (props: Props) => {
  const theme = useContext(ThemeContext);
  const [span, setSpan] = useState<number>(ONE_DIVISION)
  const [responsibleStyle, setResponsibleStyle] = useState<any>({paddingTop: 6});
  
  useEffect(() => {
    if (props.isMobile) {
      setSpan(ONE_DIVISION);
      setResponsibleStyle({ paddingTop: 6 });
    }
    else {
      setSpan(ONE_DIVISION / props.exchanges.length)
      setResponsibleStyle({ paddingTop: 6, borderTop: `2px solid ${theme.borderColor.default}` });
    }
  }, [props.isMobile])

  const isShow = useCallback(
    (idx: number) => (!props.isMobile) || (props.select === idx && props.isMobile)
    , [props.isMobile, props.select]
  )

  return (
    <>
      <div style={{ clear: 'both', float: 'right', width: "100%", position: 'absolute', textAlign: "right", top: 18, right: 70, zIndex: 99999}}>
        <a href="https://blog.naver.com/pjt3591oo" target={"_blank"} rel="noreferrer" >
          <img src={`${process.env.PUBLIC_URL}/images/naver_blog.png`} alt="네이버 블로그" style={{width: 28, height: 28, marginRight: 10}}/>
        </a>

        <a href="https://github.com/pjt3591oo" target={"_blank"} rel="noreferrer" >
          <img src={`${process.env.PUBLIC_URL}/images/github.png`} alt="깃허브" style={{width: 28, height: 28}}/>
        </a>
      </div>

      <div style={{width: "100%", height: 244, color: "#25a69a" }}>
        {props.compare}
      </div>

      <div style={{paddingTop: 18, backgroundColor: theme.background.default}}>
        <Row style={responsibleStyle}>
          {props.exchanges.map((exchange: React.ReactNode, idx: number) => (
            <Col span={span} style={{
              display: isShow(idx) ? 'block': 'none'
            }}>
              {exchange}
            </Col>
          ))}
        </Row>

        {props.fab}
      </div>
   
      {props.isMobile && (
        props.bottomNav
      )}
    </>
  );
};

export default CoinDashBoard;
